import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '~/app.module';
import { environment } from './environments/environment';

/**
 * zone.js MUST be imported AFTER AppModule/AppModuleNgFactory, otherwise it will throw
 * error "ZoneAware promise has been overriden" during bootstrapping
 */
import 'zone.js';

if (environment.production) {
  enableProdMode();
}


function sendPerfMetric(entry: PerformanceEntry) {
  const correlationId = localStorage.getItem('jaeger-debug-id') ?? null;

  const payload = {
    name: entry.name,
    type: entry.entryType,
    startTime: entry.startTime,
    duration: entry.duration,
    value: (entry as any).value ?? null,
    hadRecentInput: (entry as any).hadRecentInput ?? null,
    page: window.location.href,
    userAgent: navigator.userAgent,
    timestamp: Date.now(),
    correlationId,
  };

  navigator.sendBeacon(environment.apiUrl + 'perf-metrics', JSON.stringify(payload));
}

// LSN: long-animation-frame
if ('PerformanceObserver' in window &&
  PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) {
  const po = new PerformanceObserver((list) => {
    list.getEntries().forEach(sendPerfMetric);
  });
  po.observe({ type: 'long-animation-frame', buffered: true });
}

// CLS: layout-shift
if ('PerformanceObserver' in window &&
  PerformanceObserver.supportedEntryTypes.includes('layout-shift')) {
  const po = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      if (!(entry as any).hadRecentInput) {
        sendPerfMetric(entry);
      }
    });
  });
  po.observe({ type: 'layout-shift', buffered: true });
}

// LCP: largest-contentful-paint
if ('PerformanceObserver' in window &&
  PerformanceObserver.supportedEntryTypes.includes('largest-contentful-paint')) {
  const po = new PerformanceObserver((list) => {
    list.getEntries().forEach(sendPerfMetric);
  });
  po.observe({ type: 'largest-contentful-paint', buffered: true });
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));